"use client";

import { useTranslations } from "next-intl";
import { ExpandingArrowRight } from "../expanding-arrow-right";
import { Button } from "../ui/button";

export const ContinueButton = () => {
  const t = useTranslations("common");
  return (
    <Button
      type="submit"
      className="group mt-4 flex h-12 w-auto cursor-pointer self-center rounded-full px-4! font-medium"
    >
      {t("continue")} <ExpandingArrowRight />
    </Button>
  );
};
